import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { siteManagementRouter } from './routing/siteManagementRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { siteManagementNavigationAccessControl } from './access-control/siteManagementNavigationAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'site-management',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'site-management-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [siteManagementRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.Merchandising,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'Manage navigation menus and structure for desktop web (navigation header menu)',
          labelId: 'siteManagementDomain.navigation.page.title',
          route: 'site-management-navigation-desktop',
          accessControl: siteManagementNavigationAccessControl,
          inToolPermissions: [
            {
              slug: Permission.LegacyAdmin,
              permissionLabelId: 'permissionAccordion.permissions.' + Permission.LegacyAdmin,
            },
          ], // TODO. this cannot stay as admin
        },
      ],
    },
    {
      attachToV3: NavEntryPointV3.StorefrontPro,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'Manage navigation menus and structure for desktop web (navigation header menu)',
          labelId: 'siteManagementDomain.navigation.page.title',
          route: 'site-management-navigation-desktop',
          accessControl: siteManagementNavigationAccessControl,
          positionNavV3: 13,
          inToolPermissions: [
            {
              slug: Permission.LegacyAdmin,
              permissionLabelId: 'permissionAccordion.permissions.' + Permission.LegacyAdmin,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
  // NOTE TO DEV: run `yarn ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
